import React from "react";
import styled, { css } from "styled-components";
import { motion } from "framer-motion";
import settings from "@src/settings";
import { down } from "styled-breakpoints";

export const Frame = styled(motion.div)`
	width: 100%;
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 9;
	background-color: rgba(255, 255, 255, 0.98);
	overflow-y: scroll;
`;
export const Container = styled(motion.div)`
	width: 100%;
	position: relative;
	z-index: 0;
`;

export const CloseButtonContainer = styled.div`
	position: relative;
	z-index: 1;
	display: flex;
	justify-content: flex-end;
	width: 100%;
`;
export const CloseButton = styled.button<{ forVoice?: boolean }>`
	position: fixed;
	width: 100px;
	height: 100px;
	&:before,
	&:after {
		content: "";
		display: block;
		width: 30px;
		height: 5px;
		background-color: ${settings.color.main};
		position: absolute;
		top: 50%;
		left: 50%;
	}
	&:before {
		transform: translate(-50%, -50%) rotate(45deg);
	}
	&:after {
		transform: translate(-50%, -50%) rotate(-45deg);
	}
	${(props) =>
		props.forVoice &&
		css`
			background-color: ${settings.color.main};
			border-radius: 0 0 0 14px;
			&:before,
			&:after {
				background-color: #fff;
			}
		`}
	${down("xs")} {
		width: 75px;
		height: 75px;
	}
`;

export const CloseAtEnd = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${settings.color.paleDarker};
	width: 100%;
	height: 100px;
	& > p {
		font-family: ${settings.font.jp};
		font-weight: 700;
		font-size: 20px;
		line-height: 1;
		letter-spacing: 0.19em;
		color: ${settings.color.main};
		position: relative;
		padding-left: 24px;
		&:before,
		&:after {
			content: "";
			display: block;
			width: 20px;
			height: 3px;
			background-color: ${settings.color.main};
			position: absolute;
			top: calc(50% + 1px);
			left: 10px;
		}
		&:before {
			transform: translate(-50%, -50%) rotate(45deg);
		}
		&:after {
			transform: translate(-50%, -50%) rotate(-45deg);
		}
	}
	${down("xs")} {
		height: 56px;
		& > p {
			font-size: 18px;
			&:before,
			&:after {
				content: "";
				width: 18px;
			}
		}
	}
`;
